import React, { useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import FileViewer from "react-file-viewer";
import { SubHeadingStyled } from "../../styled/Elements";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const FileViewerModal = ({ show, onHide, fileUrl, fileType }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => {
      const videos = document.querySelectorAll(".pg-viewer video");
      videos.forEach((video) => {
        video.setAttribute("controlsList", "nodownload");
        video.removeAttribute("download");
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [show, fileUrl]);
  return (
    <ModalWrapper onContextMenu={(e) => e.preventDefault()}>
      <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
          <SubHeadingStyled color="var(--text)">
            {t("attachment_preview")}
          </SubHeadingStyled>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          {/* <div className="w-100 h-100 d-flex justify-content-center align-items-center"> */}
          {fileUrl && fileType ? (
            <FileViewer
              fileType={fileType}
              filePath={fileUrl}
              onError={(e) => {
                console.error("Error while previewing file:", e);
              }}
              errorComponent={
                <div className="text-danger text-center">
                  {t("unable_to_preview_file")}
                </div>
              }
            />
          ) : (
            <Spinner animation="border" />
          )}
          {/* </div> */}
        </Modal.Body>
      </Modal>
    </ModalWrapper>
  );
};

export default FileViewerModal;
const ModalWrapper = styled.div``;
